<template>
  <div class="navBer">
    <el-upload
      v-loading="loading"
      :http-request="upload"
      action="#"
      drag
      :limit="limit"
      :disabled="disable"
      :file-list="imgList"
      list-type="picture-card"
      :class="imgList.length >= limit ? 'hide' : 'show'"
      :before-upload="picChange"
      multiple
    >
      <div slot="default" class="up_class">
        <i class="el-icon-upload"></i>
        添加
      </div>

      <!-- 自定义文件项：支持拖拽排序 -->
      <div
        slot="file"
        slot-scope="{ file }"
        class="upload-file-item"
        :class="{
          'is-dragging':
            dragIndex !== -1 && dragIndex === getIndexByFile(file),
          'is-drag-over':
            dragOverIndex !== -1 &&
            dragOverIndex === getIndexByFile(file) &&
            dragIndex !== dragOverIndex,
        }"
        :draggable="!disable"
        @dragstart="onDragStart($event, file)"
        @dragover="onDragOver($event, file)"
        @drop="onDrop($event, file)"
        @dragend="onDragEnd"
      >
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          alt=""
          draggable="false"
        />
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disable"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <!-- 修正：遮罩层不遮挡内容 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      top="5vh"
      :modal="true"
      :modal-append-to-body="true"
      append-to-body
      :close-on-click-modal="true"
      :destroy-on-close="true"
      custom-class="preview-dialog"
      @closed="onDialogClosed"
    >
      <div class="preview-container" v-if="dialogVisible">
        <div class="preview-image-wrapper">
          <img
            class="preview-image"
            :src="currentImageUrl"
            alt="预览图片"
            @error="onImageError"
          />
        </div>

        <div
          class="preview-nav preview-nav-left"
          :class="{ 'is-disabled': imgList.length <= 1 }"
          @click.stop="prevImage"
          v-show="imgList.length > 1"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <div
          class="preview-nav preview-nav-right"
          :class="{ 'is-disabled': imgList.length <= 1 }"
          @click.stop="nextImage"
          v-show="imgList.length > 1"
        >
          <i class="el-icon-arrow-right"></i>
        </div>

        <div class="preview-indicator" v-if="imgList.length > 1">
          {{ currentIndex + 1 }} / {{ imgList.length }}
        </div>

        <div class="preview-thumbnails" v-if="imgList.length > 1">
          <div
            v-for="(item, index) in imgList"
            :key="index"
            class="thumbnail-item"
            :class="{ active: index === currentIndex }"
            @click.stop="goToImage(index)"
          >
            <img :src="item.url" alt="" />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import exoprt_file from '@/utils/expor_file'
  import { getUploadUrl } from '@/config'

  export default {
    components: {},
    props: {
      limit: {
        type: Number,
        default: 1,
      },
      disable: {
        type: Boolean,
        default: false,
      },
      imgListString: {
        type: String,
        default: null,
      },
      mask: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        title: '图片详情',
        imgList: [],
        loading: false,
        dialogImageUrl: null,
        dialogVisible: false,
        upUrl: '/index/index/file',
        currentIndex: 0,
        // ===== 拖拽排序状态 =====
        dragIndex: -1, // 当前被拖拽的项索引
        dragOverIndex: -1, // 当前悬停的目标项索引
      }
    },
    computed: {
      currentImageUrl() {
        if (this.imgList.length === 0) return ''
        const idx = Math.min(this.currentIndex, this.imgList.length - 1)
        return this.imgList[idx]?.url || ''
      },
    },
    watch: {
      imgListString: {
        handler: function (val) {
          var list = []
          this.imgList = []
          if (val) {
            list = val.split(',')
            var arrs = []
            list.forEach((item, index) => {
              arrs.push({ url: item })
            })
            this.imgList = arrs
          } else {
            list = []
          }
        },
        immediate: true,
      },
    },
    mounted() {},
    methods: {
      picChange(file) {
        console.log(file.type)
        if (
          file.type == 'image/png' ||
          file.type == 'image/jpeg' ||
          file.type == 'image/webp' ||
          file.type == 'image/jpg'
        ) {
        } else {
          this.$message({
            type: 'error',
            message: '上传失败',
          })
          return false
        }
      },
      upload(file) {
        file = file.file
        var data = {
          file: file,
        }
        this.loading = true
        exoprt_file(this.upUrl, data).then((res) => {
          var pic = getUploadUrl + res
          this.imgList = [...this.imgList, { url: getUploadUrl + res }]
          this.loading = false
          this.emitChange()
        })
      },
      handleRemove(file) {
        var url = file.url
        this.imgList.forEach((item, index) => {
          if (url == item.url) {
            delete this.imgList.splice(index, 1)
          }
        })
        this.emitChange()
      },
      emitChange() {
        var arr = []
        this.imgList.forEach((item, index) => {
          arr.push(item.url)
        })
        this.$emit('fileChange', arr)
      },
      handlePictureCardPreview(file) {
        const index = this.imgList.findIndex((item) => item.url === file.url)
        this.currentIndex = index >= 0 ? index : 0
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      prevImage() {
        if (this.imgList.length <= 1) return
        this.currentIndex =
          (this.currentIndex - 1 + this.imgList.length) % this.imgList.length
      },
      nextImage() {
        if (this.imgList.length <= 1) return
        this.currentIndex = (this.currentIndex + 1) % this.imgList.length
      },
      goToImage(index) {
        this.currentIndex = index
      },
      onImageError() {
        this.$message.warning('图片加载失败')
      },
      onDialogClosed() {
        this.currentIndex = 0
      },

      /* ==================== 拖拽排序 ==================== */
      /**
       * 根据 el-upload 透出的 file 对象，找到它在 imgList 中的索引
       * 优先使用 uid（el-upload 内部会写入），兜底用 url 匹配
       */
      getIndexByFile(file) {
        if (!file) return -1
        if (file.uid !== undefined && file.uid !== null) {
          const uidIndex = this.imgList.findIndex((item) => item.uid === file.uid)
          if (uidIndex !== -1) return uidIndex
        }
        return this.imgList.findIndex((item) => item.url === file.url)
      },

      onDragStart(e, file) {
        if (this.disable) return
        const index = this.getIndexByFile(file)
        if (index === -1) return

        this.dragIndex = index
        this.dragOverIndex = index

        e.dataTransfer.effectAllowed = 'move'
        // Firefox 必须 setData，否则拖拽不生效
        try {
          e.dataTransfer.setData('text/plain', String(index))
        } catch (err) {
          /* 忽略 */
        }
      },

      onDragOver(e, file) {
        // 只有从列表内部开始的拖拽才允许 drop
        if (this.dragIndex === -1) return
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'

        const index = this.getIndexByFile(file)
        if (index !== -1 && index !== this.dragOverIndex) {
          this.dragOverIndex = index
        }
      },

      onDrop(e, file) {
        if (this.dragIndex === -1) {
          this.resetDragState()
          return
        }
        e.preventDefault()
        e.stopPropagation()

        const fromIndex = this.dragIndex
        const toIndex = this.getIndexByFile(file)

        this.resetDragState()

        if (toIndex === -1 || toIndex === fromIndex) return

        // 就地重排 imgList
        const list = this.imgList.slice()
        const [moved] = list.splice(fromIndex, 1)
        list.splice(toIndex, 0, moved)
        this.imgList = list

        // 同步预览的当前索引，避免排序后错位
        if (this.dialogVisible) {
          this.currentIndex = toIndex
        }

        // 通知父组件顺序变化
        this.emitChange()
      },

      onDragEnd() {
        this.resetDragState()
      },

      resetDragState() {
        this.dragIndex = -1
        this.dragOverIndex = -1
      },
    },
  }
</script>

<style>
  .el-upload-list__item-thumbnail {
    transition: none !important;
  }
  .murked canvas {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
</style>

<style scoped lang="scss">
  .pdf {
    position: relative;
  }
  .pdf_meng {
    position: absolute;
    top: 200px;
    left: 200px;
    width: 150px;
    height: 30px;
    z-index: 100;
    background-color: #ccc;
  }

  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
  ::v-deep .el-upload-list__item.is-ready {
    display: none;
  }
  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 100%;
  }
  .show {
    display: flex;
    flex-wrap: wrap;
  }
  .navBer::v-deep .el-upload-list--picture-card {
    margin: 0;
    display: block;
    display: contents;
  }

  .navBer::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    border-radius: 8px;
  }
  .navBer::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    border-radius: 8px;
  }

  .up_class {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100px;
    height: 100px;
    line-height: 20px;
  }
  ::v-deep .el-upload-dragger .el-icon-upload {
    margin: 0;
  }
  .hide {
    position: relative;
    float: left;
    ::v-deep {
      .el-upload--picture-card {
        display: none;
      }

      .el-upload-list__item {
        border: 0;
        border-radius: 0;
      }
    }
  }

  /* ==================== 拖拽排序样式 ==================== */
  .upload-file-item {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: grab;
    user-select: none;
  }

  .upload-file-item:active {
    cursor: grabbing;
  }

  /* 被拖拽中的项：半透明 */
  .upload-file-item.is-dragging {
    opacity: 0.35;
    cursor: grabbing;
  }

  /* 拖拽悬停的目标项：高亮虚线框 */
  .upload-file-item.is-drag-over::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 2px dashed #409eff;
    border-radius: 8px;
    background: rgba(64, 158, 255, 0.18);
    pointer-events: none;
    z-index: 5;
    box-sizing: border-box;
  }

  /* 拖拽时禁用缩略图自身的原生拖拽视觉 */
  .upload-file-item img {
    -webkit-user-drag: none;
    user-select: none;
  }

  /* ========== 预览弹窗样式修正 ========== */
  /* 关键：确保遮罩层在弹窗下方，弹窗内容可点击 */
  ::v-deep .v-modal {
    z-index: 2000 !important;
  }

  ::v-deep .preview-dialog {
    z-index: 2001 !important;
    background: #1a1a1a;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
    overflow: hidden;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }

  /* 关键：确保 el-dialog 的 wrapper 层级正确 */
  ::v-deep .el-dialog__wrapper {
    z-index: 2001 !important;
  }

  ::v-deep .preview-dialog .el-dialog__header {
    // padding: 15px 20px;
    // background: #2c2c2c;
    // border-bottom: 1px solid #3a3a3a;
    // border-radius: 12px 12px 0 0;
  }

  ::v-deep .preview-dialog .el-dialog__title {
    color: #fff;
    font-size: 16px;
  }

  ::v-deep .preview-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #aaa;
    font-size: 20px;
  }

  ::v-deep .preview-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .preview-dialog .el-dialog__body {
    padding: 0;
    flex: 1;
    overflow: hidden;
    background: #1a1a1a;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
  }

  .preview-container {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 60px;
    box-sizing: border-box;
  }

  .preview-image-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    max-height: 70vh;
    overflow: hidden;
  }

  .preview-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    transition: transform 0.3s ease;
  }

  .preview-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
    user-select: none;
  }

  .preview-nav:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-50%) scale(1.05);
  }

  .preview-nav.is-disabled {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }

  .preview-nav-left {
    left: 16px;
  }

  .preview-nav-right {
    right: 16px;
  }

  .preview-indicator {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    color: #ccc;
    font-size: 14px;
    background: rgba(0, 0, 0, 0.6);
    padding: 4px 16px;
    border-radius: 20px;
    backdrop-filter: blur(4px);
    z-index: 10;
  }

  .preview-thumbnails {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 30px;
    backdrop-filter: blur(6px);
    max-width: 80%;
    overflow-x: auto;
    z-index: 10;
  }

  .preview-thumbnails::-webkit-scrollbar {
    height: 4px;
  }

  .preview-thumbnails::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  .thumbnail-item {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease;
    flex-shrink: 0;
    opacity: 0.7;
  }

  .thumbnail-item:hover {
    opacity: 1;
    transform: scale(1.05);
  }

  .thumbnail-item.active {
    border-color: #409eff;
    opacity: 1;
    box-shadow: 0 0 12px rgba(64, 158, 255, 0.6);
  }

  .thumbnail-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    .preview-container {
      padding: 20px 30px;
    }
    .preview-nav {
      width: 36px;
      height: 36px;
      font-size: 18px;
    }
    .preview-nav-left {
      left: 8px;
    }
    .preview-nav-right {
      right: 8px;
    }
    .thumbnail-item {
      width: 36px;
      height: 36px;
    }
    .preview-indicator {
      bottom: 70px;
      font-size: 12px;
    }
  }
</style>